<template>
  <div>
    <h3 class="mb-4">Warehouse Stock Transfer</h3>
    <p class="mb-2 transfer-description">
      Pindahkan stok TV dan Bracket antar warehouse. Source dan destination warehouse harus berbeda.
    </p>

    <div v-if="result" class="transfer-result mb-6">
      <strong>Transfer berhasil.</strong>
      <div>{{ result }}</div>
    </div>

    <div class="vx-row mb-4">
      <div class="vx-col w-full md:w-1/3">
        <label class="vs-input--label pl-0">Source Warehouse</label>
        <vs-select
          class="selectExample"
          v-model="form.old_warehouse"
          width="100%"
          autocomplete
          @input-change="searchDropdown($event, warehouse)"
        >
          <vs-select-item
            v-for="(item, index) in warehouse.data"
            :key="index"
            :value="item.warehouses_code"
            :text="item.warehouses_code"
          />
        </vs-select>
      </div>

      <div class="vx-col w-full md:w-1/3">
        <label class="vs-input--label pl-0">Destination Warehouse</label>
        <vs-select
          class="selectExample"
          v-model="form.new_warehouse"
          width="100%"
          autocomplete
          @input-change="searchDropdown($event, warehouse)"
        >
          <vs-select-item
            v-for="(item, index) in warehouse.data"
            :key="index"
            :value="item.warehouses_code"
            :text="item.warehouses_code"
          />
        </vs-select>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col w-full md:w-1/3">
        <vs-input type="number" min="0" class="w-full" label="TV Qty" v-model="form.tv_qty" @keypress="isNumber($event)" />
      </div>
      <div class="vx-col w-full md:w-1/3">
        <vs-input type="number" min="0" class="w-full" label="Bracket Qty" v-model="form.bracket_qty" @keypress="isNumber($event)" />
      </div>
    </div>

    <div class="flex justify-end">
      <vs-button
        color="primary"
        type="filled"
        icon="icon-log-in"
        icon-pack="feather"
        class="btn"
        :disabled="!isValid"
        @click="showConfirmModal = true"
      >Process</vs-button>
    </div>

    <vs-popup title="Konfirmasi Warehouse Stock Transfer" :active.sync="showConfirmModal">
      <div class="vx-col w-full">
        <p class="mb-4">Yakin ingin memindahkan stok berikut?</p>
        <p class="mb-1"><strong>Source:</strong> {{ form.old_warehouse }}</p>
        <p class="mb-1"><strong>Destination:</strong> {{ form.new_warehouse }}</p>
        <p class="mb-1"><strong>TV Qty:</strong> {{ tvQtyNum }}</p>
        <p class="mb-4"><strong>Bracket Qty:</strong> {{ bracketQtyNum }}</p>
        <div class="flex justify-end">
          <vs-button color="danger" type="border" class="mr-2" @click="showConfirmModal = false">Batal</vs-button>
          <vs-button color="success" type="filled" :disabled="isSubmitting" @click="confirmTransfer">
            {{ isSubmitting ? "Memproses..." : "Ya, Process" }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "StockTransferWarehouse",
  data() {
    return {
      warehouse: {
        data: [],
        loading: false,
        endpoint: "master/warehouses",
        objectKey: "warehouses_code",
      },
      form: {
        old_warehouse: "",
        new_warehouse: "",
        tv_qty: "",
        bracket_qty: "",
      },
      showConfirmModal: false,
      isSubmitting: false,
      result: null,
      sameWarehouseNotified: false,
    };
  },
  computed: {
    tvQtyNum() {
      return parseInt(this.form.tv_qty, 10) || 0;
    },
    bracketQtyNum() {
      return parseInt(this.form.bracket_qty, 10) || 0;
    },
    isSameWarehouse() {
      return Boolean(
        this.form.old_warehouse &&
        this.form.new_warehouse &&
        this.form.old_warehouse === this.form.new_warehouse
      );
    },
    isValid() {
      return Boolean(
        this.form.old_warehouse &&
        this.form.new_warehouse &&
        !this.isSameWarehouse &&
        (this.tvQtyNum > 0 || this.bracketQtyNum > 0)
      );
    },
  },
  watch: {
    "form.old_warehouse"() {
      this.checkSameWarehouse();
    },
    "form.new_warehouse"() {
      this.checkSameWarehouse();
    },
  },
  mounted() {
    this.fetchWarehouses();
  },
  methods: {
    fetchWarehouses() {
      this.$emit("loading", true);
      this.$http
        .post(this.warehouse.endpoint)
        .then((res) => {
          this.warehouse.data = res.data.data || [];
        })
        .catch((error) => this.$emit("error", error))
        .finally(() => this.$emit("loading", false));
    },
    checkSameWarehouse() {
      if (this.isSameWarehouse && !this.sameWarehouseNotified) {
        this.sameWarehouseNotified = true;
        this.$vs.notify({
          color: "danger",
          title: "Validasi",
          text: "Source dan destination warehouse tidak boleh sama.",
          time: 6000,
        });
      } else if (!this.isSameWarehouse) {
        this.sameWarehouseNotified = false;
      }
    },
    async confirmTransfer() {
      this.isSubmitting = true;
      this.$emit("loading", true);
      try {
        const res = await this.$http.post("support/inventory/stock-transfer", {
            old_warehouse: this.form.old_warehouse,
            new_warehouse: this.form.new_warehouse,
            tv_qty: this.tvQtyNum,
            bracket_qty: this.bracketQtyNum,
        });
        this.result = res.data.message || "Warehouse transfer stock success.";
        this.showConfirmModal = false;
        this.$vs.notify({
          color: "success",
          title: "Success",
          iconPack: "feather",
          icon: "icon-check",
          text: this.result,
        });
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.isSubmitting = false;
        this.$emit("loading", false);
      }
    },
  },
};
</script>

<style scoped>
.transfer-description {
  color: #6b7280;
  font-size: 13px;
}
.transfer-result {
  padding: 12px 16px;
  border: 1px solid #86efac;
  border-radius: 6px;
  background: #f0fdf4;
  color: #166534;
  font-size: 13px;
}
</style>
